import {TooltipAttrs} from 'common/components/tooltip/types';

export enum LinkNodeStyle {
  Link = `link`,
  Selected = `selected`,
  Secondary = `secondary`,
}

export type LinkNode = {
  label: string;
  tooltip?: TooltipAttrs;
  url?: string;
  // if unspecified, will default to LinkNodeStyle.Link
  style?: LinkNodeStyle;
  value?: string | number;
  disabled?: boolean;
  isInEditMode?: boolean;
};

export type BreadcrumbsState = {
  linkNodes: LinkNode[];
};
